import React, { useEffect, useState } from "react";
import "./DeleteNotification.css";
import CloseIcon from "../../assets/Modal-Close-Icon.svg";
import { showErrorNotification, showSuccessNotification } from "../Tostify";
import {
  API_Notification,
  GetAllNotification_M3,
} from "../../../../api/notifyapi/Notifyapi";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import { NotificationActions } from "../../../../slices/NotificationSlice";
import { NOTIFICATION_MESSAGES } from "../CreateAndEditNotify/FormDataConstants";
import Loader from "../../loader/Loader";

const DeleteNotification: React.FC = () => {
  const id = useSelector(
    (state: RootState) => state.notification.SetEditAndDeleteId
  );
  const dispatch = useDispatch<AppDispatch>();
  const [deleteId, setDeleteId] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiQuery = useSelector(
    (state: RootState) => state.notification.searchFilter.apiQuery
  );

  useEffect(() => {
    setDeleteId(id);
  }, [id]);

  // Function to Handle the delete the notification
  const handleDeleteNotification = async (): Promise<void> => {
    try {
      setIsLoading(true);
      // First attempt the API call
      const response = await API_Notification.DeleteNotification(deleteId);
      if (response) {
        showSuccessNotification(NOTIFICATION_MESSAGES.DELETE_SUCCESS);
        dispatch(NotificationActions.UpdateDeletePopup(false));
        // If you still need to fetch fresh data
        dispatch(GetAllNotification_M3(apiQuery));
      }
    } catch (error) {
      showErrorNotification(NOTIFICATION_MESSAGES.DELETE_ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClosePopup = (): void => {
    dispatch(NotificationActions.UpdateDeletePopup(false));
  };

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-content">
        <div className="delete-modal-header">
          <div className="project-title popup-head">Delete Notification</div>
          <img
            src={CloseIcon}
            alt="close-icon"
            className="close-btn"
            onClick={handleClosePopup}
            style={{ position: "relative", left: "70px" }}
          />
        </div>
        <div className="delete-modal-body">
          <p>Are you sure you want to proceed to delete this notification?</p>
        </div>
        <div className="delete-modal-footer">
          <button
            className="popup-create-btn delete-button"
            onClick={() => handleDeleteNotification()}
          >
            Delete
            {isLoading ? <Loader /> : <></>}
          </button>
          <button className="popup-Cancel-btn" onClick={handleClosePopup}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteNotification;
